import { Paper, Box, Typography, Stack } from '@mui/material';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { tokens } from '../../../theme/theme';
import { severityColor } from '../../../utils/severity';

export default function SeverityBreakdown({ data }) {
  if (!data?.length) return null;
  const total = data.reduce((s, d) => s + d.value, 0);

  return (
    <Paper sx={{ p: 2.4, height: '100%' }}>
      <Typography variant="overline" sx={{ color: tokens.text.muted, fontSize: '0.65rem' }}>
        Active Threats by Severity
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box sx={{ width: 120, height: 120, flexShrink: 0 }}>
          <ResponsiveContainer>
            <PieChart>
              <Pie data={data} dataKey="value" innerRadius={38} outerRadius={58} paddingAngle={3} stroke="none">
                {data.map((d) => <Cell key={d.key} fill={severityColor(d.key)} />)}
              </Pie>
              <Tooltip
                contentStyle={{ backgroundColor: tokens.bg.elevated, border: `1px solid ${tokens.border}`, borderRadius: 8, fontSize: 12 }}
              />
            </PieChart>
          </ResponsiveContainer>
        </Box>
        <Stack spacing={1} sx={{ flex: 1 }}>
          {data.map((d) => (
            <Box key={d.key} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: severityColor(d.key) }} />
                <Typography variant="body2" sx={{ color: tokens.text.secondary, fontSize: '0.8rem' }}>{d.name}</Typography>
              </Box>
              <Typography variant="body2" sx={{ color: tokens.text.primary, fontFamily: '"JetBrains Mono", monospace', fontSize: '0.8rem' }}>
                {d.value} <Box component="span" sx={{ color: tokens.text.muted }}>({Math.round((d.value / total) * 100)}%)</Box>
              </Typography>
            </Box>
          ))}
        </Stack>
      </Box>
    </Paper>
  );
}
